import axiosInstance from 'api/axiosInstance'

export const putStorySettings = async (
  setup: Record<string, string[] | number[] | boolean>
) => {
  const { data } = await axiosInstance({
    method: 'POST',
    url: '/api/story/settings',
    data: setup
  })

  return data
}
export const getOtherProfileWithGroups = async (userId: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/${userId}/groups`
    })
    return data?.data
}

export const getDefaultStoryVisibilityGroups = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/story/default-visibility-groups'
    })
    return data
}